import constant from '../../constant';
import request from "../../../utils/request";
import {GET_ACTIVITY_LIST, GET_COMMODITY_DETAIL} from "../../../urls";
import {query, showTip} from "../../../utils";
import {reportEcommerce} from "../../../utils/stat";
import {addStopScrollListener, delStopScrollListener} from "../../../utils/yUtil";

const getActivity = (params = {}) => {
  return async (dispatch) => {
    const { userInfo: {uin = '', type = ''} = {} } = params;
    const activity_id = query('activityId') || '';
    const live_id = query('liveId') || '';
    const channel_id = query('ch') || '';
    const extra_info = query('extra_info') || '';

    try {
      const result = await request.get(GET_ACTIVITY_LIST, {
        uin, type, activity_id, live_id, channel_id, extra_info
      });
      if (result.code === 0 && result.ret) {
        const ret = result.ret || {};
        const {backInfo = {}, activity_commodities = [],  activity_detail: {begin_time, end_time} = {}, actStatus, remainSeconds } = ret;
        const commodityTabMap = {};
        let tabs = [];
        activity_commodities.map(item => {
          if (item.valid_date) {
            if (tabs.indexOf(item.valid_date) < 0) {
              tabs.push(item.valid_date);
            }
            if (!commodityTabMap[item.valid_date]) {
              commodityTabMap[item.valid_date] = [];
            }
            commodityTabMap[item.valid_date].push(item);
          }
        });

        tabs = tabs.map(item => Number(item)).sort();
        const currentDate = Number(result.currentDate);
        let initSelectDate = currentDate;
        if (tabs.length > 0) {
         if (!(initSelectDate >= tabs[0] && initSelectDate <= tabs[tabs.length - 1] && tabs.indexOf(currentDate) > -1)) {
           initSelectDate = tabs[0];
         }
        }
        dispatch(getActivitySuccess({activityInfo: {
            begin_time: begin_time ? Number(begin_time) * 1000 : '',
            end_time: begin_time ? Number(end_time) * 1000 : ''
        }, commodityTabMap, tabs, currentDate, initSelectDate, sign1: result.sign1, backInfo,
          actStatus: result.actStatus, remainSeconds: result.remainSeconds, initInterval: result.initInterval
        }));
        if (activity_commodities.length) {
          reportEcommerce(2, 'shop_list')
        }
      }else {
        // todo 跳错误页
        showTip('服务异常，请刷新重试')
      }
      // dispatch(getActivitySuccess(defaultData))
    }catch (e) {
      console.log('获取活动信息失败', e);
      // todo 跳错误页
      // dispatch(getActivity(defaultData));
      showTip(e.msg || '服务异常，请刷新重试')
    }
  }
}
const getActivitySuccess = (clipboard) => {
  return {
    type: constant.E_COMMERCE_FISSION.ACTIVITY_DATA,
    ...clipboard
  }
}

const getCommodity = (params = {}) => {
  return async (dispatch) => {
    const { uin = '', type = ''} = params;
    const activity_id = query('activityId') || '';
    const live_id = query('liveId') || '';
    const channel_id = query('ch') || '';
    const extra_info = query('extra_info') || '';
    const share_id = query('shareId') || '';
    const share_id_type = query('type') || '';
    const shareGuid = query('shareGuid');
    const sign1 = query('sign1') || '';
    const sign2 = query('sign2') || '';
    const commodity_id = query('id') || '';
    const validDate = query('validDate') || '';
    try {
      const result = await request.get(GET_COMMODITY_DETAIL, {
        uin, type, share_id, share_id_type, shareGuid, activity_id, live_id, channel_id, extra_info, sign1, sign2, commodity_id, validDate
      });

      if (result.code === 0 && result.ret) {
        const {assistance_info = [], commodity_detail: {need_score = 0, commodity_id} = {}, activity_deadline: {begin_time, end_time = {}}, actStatus, remainSeconds} = result.ret || {};
        let total = 0, remainScore;
        assistance_info.forEach(item => {
          if (!isNaN(item.helper_scores)) {
            total += Number(item.helper_scores);
          }
        });
        remainScore = need_score - total;
        commodity_id && dispatch(getCommoditySuccess({...result.ret,
          need_score, total, remainScore,
          activityInfo: {
            begin_time: begin_time ? Number(begin_time) * 1000 : '',
            end_time: begin_time ? Number(end_time) * 1000 : ''
          },
          commodity: result.ret.commodity_detail,
          currentDate: result.currentDate,
          actStatus: result.actStatus, remainSeconds: result.remainSeconds, initInterval: result.initInterval
        }))
        if (!commodity_id) {
          showTip( '页面信息异常，请刷新页面重试')
        }
      }else {
        // todo 跳错误页
        showTip( result.code === -3 ? '很抱歉！检测到你的账号可能有异常' : '服务异常，请刷新重试')
      }
    }catch (e) {
      console.log('获取商品信息失败', e);
      // todo 跳错误页
      showTip(e.msg || '服务异常，请刷新重试')
    }
  }
}
const getCommoditySuccess = (data) => {
  return {
    type: constant.E_COMMERCE_FISSION.COMMODITY_DETAIL,
    ...data
  }
}

const loadDialog = (params = {}) => {
  if (params.show || params.showHelpDialoag || params.showRuleDialog) {
    addStopScrollListener();
  }else {
    delStopScrollListener();
  }
  return {
    type: constant.E_COMMERCE_FISSION.DIALOG,
    ...params
  }
}

const refreshAssistantList = (params = {}) => {

}


export default {
  getActivity,
  getCommodity,
  loadDialog,
  refreshAssistantList
}